import {useDispatch} from 'react-redux'
import {sleep} from '../../Helpers/utils'
import {setCapturedImage} from '../../redux/actions'

export const captureFromCamera = async () => {
  const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  const video = document.createElement("video");
  video.srcObject = stream;
  // Await metadata so videoWidth/videoHeight are available
  await new Promise((resolve, reject) => {
    video.onloadedmetadata = resolve;
    video.onerror = reject;
  });
  video.width = video.videoWidth;
  video.height = video.videoHeight;
  // play() can reject in some environments; awaiting keeps errors in the same try/catch
  await video.play();
  const canvas = document.createElement("canvas");
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const ctx = canvas.getContext("2d");
  await sleep(500); // prevent black images on some browsers
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  stream.getVideoTracks()[0].stop();
  return  canvas.toDataURL("image/jpeg");
}

const useCapturePhoto = () => {
  const dispatch = useDispatch()

  const capturePhotoToStore = async ({toStore = true} = {}) => {
    try {
      const imageUrl = await captureFromCamera()
      console.log('gizim', 5127310, ' ');

      if (toStore) {
        dispatch(setCapturedImage(imageUrl))
      }
      console.log('gizim', 7519388, ' ');

      return imageUrl
    } catch (err) {
      console.error("An error occurred:", err);
    }
  };

  return [capturePhotoToStore];
};

export default useCapturePhoto;
